// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PrintEducationSlideMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  pathToPrint: Types.Scalars['String']['input'];
}>;


export type PrintEducationSlideMutation = { __typename?: 'Mutation', printV2: { __typename?: 'FileDownloadToken', token: string, expiresInSeconds: number } };

export const Operations = {
  Mutation: {
    PrintEducationSlide: 'PrintEducationSlide' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const PrintEducationSlideDocument = gql`
    mutation PrintEducationSlide($householdId: ID!, $pathToPrint: String!) {
  printV2(input: {householdID: $householdId, relativePath: $pathToPrint}) {
    token
    expiresInSeconds
  }
}
    `;
export type PrintEducationSlideMutationFn = Apollo.MutationFunction<PrintEducationSlideMutation, PrintEducationSlideMutationVariables>;

/**
 * __usePrintEducationSlideMutation__
 *
 * To run a mutation, you first call `usePrintEducationSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintEducationSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printEducationSlideMutation, { data, loading, error }] = usePrintEducationSlideMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      pathToPrint: // value for 'pathToPrint'
 *   },
 * });
 */
export function usePrintEducationSlideMutation(baseOptions?: Apollo.MutationHookOptions<PrintEducationSlideMutation, PrintEducationSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintEducationSlideMutation, PrintEducationSlideMutationVariables>(PrintEducationSlideDocument, options);
      }
export type PrintEducationSlideMutationHookResult = ReturnType<typeof usePrintEducationSlideMutation>;
export type PrintEducationSlideMutationResult = Apollo.MutationResult<PrintEducationSlideMutation>;
export type PrintEducationSlideMutationOptions = Apollo.BaseMutationOptions<PrintEducationSlideMutation, PrintEducationSlideMutationVariables>;